export default "__VITE_ASSET__93cdf641__"